import { useLocation } from 'react-router-dom'
import { useStore } from '~hooks'
import * as Styled from './styled'

function Navbar() {
  const store = useStore()
  const location = useLocation()

  function handleClickFreights() {
    if (location.pathname.includes('/dados-veiculo'))
      store.update({ saveVehicleDataModal: true, saveVehicleDataCallback: () => window.location.href = '/fretes' })
    else window.location.href = '/fretes'
  }

  function handleClickHelp() {
    if (location.pathname.includes('/dados-veiculo'))
      store.update({ saveVehicleDataModal: true, saveVehicleDataCallback: () => window.location.href = '/ajuda-e-atendimento' })
    else window.location.href = '/ajuda-e-atendimento'
  }

  return (
    <Styled.Navbar data-testid="navbar">
      <Styled.Option onClick={handleClickFreights}>
        Fretes
      </Styled.Option>
      <Styled.Option onClick={handleClickHelp}>
        Atendimento
      </Styled.Option>
    </Styled.Navbar>
  )
}

export default Navbar
